import React from "react"
import { has } from "lodash"

import RequestBuild from "./../../requestBuild/RequestBuild"
import Error from "./../../general/Error"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faWrench, faSpinner } from "@fortawesome/free-solid-svg-icons"

class ManageBuild extends React.Component{
    constructor(props){
        super(props)
        this.state={
            appConfig: [],
            error: "",
            isLoading: true,
            isAdmin: props.user.permissions.includes("ARCADE/SUPER_PERMISSION[DEPRECATED]"),
        }
    }
    getAppConfig = () =>{
        fetch(`/api/data/project/${this.props.id}/appConfig/list`)
        .then(res => res.json())
        .then(data => {
            if (has(data, "error")){ throw data }
            this.setState({
                appConfig: data.result,
                isLoading: false 
            })
        })
        .catch(data=> this.setState({error: `Server: ${data.error}`, isLoading: false}))
    }
    componentDidMount(){
        this.getAppConfig()
    }
    render(){
        const { id } = this.props
        const { error, appConfig, isLoading, isAdmin } = this.state
        if (error !== ""){
            return(
                <Error error={error} />
            )
        }
        return(
            <div className="manageSection" id="manageBuild">
                <div className="manageHeader">
                    <div className="svgContainer">
                        <FontAwesomeIcon icon={faWrench} />
                    </div>
                    <div className="introText">
                        <h1 className="headerTitle">Request Build</h1>
                        <p>Request build for your game for publishing!</p>
                    </div>
                </div>
                {isLoading
                    ? <div className="reviews loading"><FontAwesomeIcon icon={faSpinner} spin /></div>
                    : <RequestBuild projectId={id} appConfig={appConfig} 
                        getAppConfig={this.getAppConfig} isAdmin={isAdmin}/>
                }
            </div>
        )
    }
}

export default ManageBuild